//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapActions, mapGetters, mapMutations } from "vuex";
import addEditRole from "@/components/Admin/RolesAndUsers/AddEditRole/adminAddEditRole.vue";
import AdminAddEditUser from "@/components/Admin/RolesAndUsers/AdminAddEditUser/AdminAddEditUser.vue";
import FabricSearch from "@/components/q-fabric-search.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import userColumns from "../../UserManagement/columns";
import roleColumns from "../../RolesManagement/columns";

export default {
    name: "AddNewRoleUser",
    components: {
        AdminAddEditUser,
        addEditRole,
        FabricSearch,
        AQToggle,
        AQButton,
        AQAvatar
    },
    filters: {
        dateFormat(value) {
            return `${date.formatDate(value, "DD.MM.YYYY")} at ${date.formatDate(value, "HH:mm:ss")}`;
        }
    },
    props: {
        dashboard: {
            type: Boolean,
            required: false,
            default: false
        },
        appSettings: {
            type: Boolean,
            default: false
        },
        createRolePermissons: {
            type: Boolean,
            default: false
        },
        manageGroupsType: {
            type: Boolean,
            default: false
        },
        allowAppEdit: {
            type: Boolean,
            default: false
        },
        specificGroups: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dataLoaded: false,
            isRole: false,
            roleColumns,
            userColumns,
            activateModalRole: false,
            createNewRole: false,
            showEditRole: false,
            showEditUser: false,
            editRoleBtn: false,
            inEditRow: null,
            hasClose: true,
            hasCancel: false,
            userModal: false,
            manualAddModal: false,
            editUserBtn: false,
            clicked: false,
            filter: "",
            allSearchItems: [],
            filteredRoleItems: [],
            filteredUsersItems: [],
            allGroupList: [],
            allGroupsTenantProcess: [],
            activeGroupsList: [],
            page: "browseUsers",
            optionsBrowse: [
                { label: this.$t("admin.usersAndRoles.browseUsers"), value: "browseUsers" },
                { label: this.$t("admin.usersAndRoles.browseRoles"), value: "browseGroups" }

            ],
            showActiveGroups: true,
            showDisabledDate: false
        };
    },
    computed: {
        ...mapGetters("admin", [
            "roleList",
            "roleTableData",
            "loadingRoles",
            "getRoleDataByID",
            "userList",
            "getGroupsListApp"
        ]),
        ...mapGetters("apps", ["apps"]),
        roleName() {
            return this.roleTableData.name;
        },
        data() {
            let list;
            if (this.isRole) {
                if (this.manageGroupsType) {
                    list = this.allGroupsTenantProcess;
                } else {
                    list = this.allGroupList;
                }
            } else {
                list = this.userList;
            }
            return list;
        },
        tableRoleList() {
            let dataToReturn;
            if (this.manageGroupsType) {
                if (!this.dashboard) {
                    dataToReturn = this.allGroupsTenantProcess;
                } else {
                    dataToReturn = this.allGroupsTenantProcess.slice(0, 10);
                }
            } else if (!this.dashboard) {
                dataToReturn = this.allGroupList;
            } else {
                dataToReturn = this.allGroupList.slice(0, 10);
            }
            return dataToReturn;
        },
        tableUserList() {
            return !this.dashboard ? this.userList : this.userList.slice(0, 10);
        },
        paginationControl: {
            get() {
                let rows;
                if (this.isRole) {
                    if (this.manageGroupsType) {
                        rows = this.allGroupsTenantProcess.length;
                    } else {
                        rows = this.roleTableData.length;
                    }
                } else {
                    rows = this.userList.length;
                }
                return {
                    rowsPerPage: rows,
                    page: 1
                };
            },
            set() {}
        }
    },
    watch: {
        allowAppEdit: {
            handler(val) {
                if (val) {
                    this.actionGetGroupsApps();
                }
            }
        },
        avatar: {
            handler() {
                this.saved = false;
            },
            deep: true
        },
        manageGroupsType: {
            handler(newValue) {
                this.isRole = newValue;
            },
            immediate: true
        },
        getGroupsListApp: {
            handler(newValue) {
                const filterData = newValue.filter(item => item.type === "TPD");
                const uniqueArray = [...new Set(filterData.map(elem => elem))];
                this.allGroupsTenantProcess = uniqueArray;
                this.activeGroupsList = uniqueArray.filter(elem => elem.active);
            },
            immediate: true
        },
        roleList: {
            handler(newValue) {
                if (this.apps && this.apps.length) {
                    this.allGroupList = this.setAllDetailsGroupsList([...newValue]);
                }
            },
            immediate: true
        },
        apps: {
            handler() {
                if (this.roleList && this.roleList.length) {
                    this.allGroupList = this.setAllDetailsGroupsList([...this.roleList]);
                }
            },
            immediate: true
        },
        allGroupsTenantProcess: {
            handler(newValue) {
                this.activeGroupsList = newValue ? newValue.filter(elem => elem.active) : [];
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {
        if (!this.manageGroupsType) {
            this.getUsersList();
        } else {
            this.dataLoaded = true;
            this.manageGroupsApplication();
        }
        this.getRoleList();
    },
    activated() {
        this.$store.commit("rules/setShowRuleTesting", false);
        if (this.dataLoaded) {
            this.manageGroupsApplication();
        }
    },
    deactivated() {
        this.setGroupsAppList();
    },
    methods: {
        ...mapActions("admin", [
            "getRoleList",
            "deleteRole",
            "editRole",
            "getUsersList",
            "createNewUser",
            "actionGetGroupsApps"
        ]),
        ...mapMutations("main", ["setInterfaceDirty"]),
        ...mapMutations("admin", ["setGroupsAppList"]),
        updateView(page) {
            if (page === "browseUsers") {
                this.isRole = false;
            } else if (page === "browseGroups") {
                this.isRole = true;
            }
        },
        selectiveClick(data) {
            if (data.name) {
                this.editRole(data);
            } else if (data.firstName || data.lastName || data.username) {
                this.editUser(data);
            }
        },
        updateRoleList() {
            this.actionGetGroupsApps();
        },
        functionForNrOfUsersAndGoups(propsSent) {
            let numberOfUsersAndGroups = "";
            const props = JSON.parse(JSON.stringify(propsSent));
            props.nrOfUsers = parseInt(props.nrOfUsers, 10);
            props.nrOfGroups = parseInt(props.nrOfGroups, 10);
            if (props.nrOfGroups !== 0) {
                numberOfUsersAndGroups += `${props.nrOfGroups} `;
                if (props.nrOfGroups === 1) {
                    numberOfUsersAndGroups += this.$t("admin.usersAndRoles.role");
                } else {
                    numberOfUsersAndGroups += this.$t("admin.usersAndRoles.rolesLower");
                }
            }
            if (props.nrOfGroups !== 0 && props.nrOfUsers !== 0) {
                numberOfUsersAndGroups += this.$t("admin.usersAndRoles.and");
            }
            if (props.nrOfUsers !== 0) {
                numberOfUsersAndGroups += `${props.nrOfUsers} `;
                if (props.nrOfUsers === 1) {
                    numberOfUsersAndGroups += this.$t("admin.usersAndRoles.user");
                } else {
                    numberOfUsersAndGroups += this.$t("admin.usersAndRoles.usersLower");
                }
            }
            return numberOfUsersAndGroups;
        },
        setAllDetailsGroupsList(data) {
            const dataToReturn = data.map(group => {
                const groupToReturn = JSON.parse(JSON.stringify(group));
                const coreGroups = ["ADMIN", "ALL_USERS", "EXT_USERS", "APPS_CREAT"];
                if (groupToReturn.type === "TPD") {
                    const setApp = this.apps.filter(elem => elem.id === group.processDefinitionId)[0];
                    groupToReturn.description = setApp ? this.$t("admin.usersAndRoles.groupTPD") + setApp.name : "";
                } else if (groupToReturn.type === "EXTERNAL") {
                    groupToReturn.description = this.$t("admin.usersAndRoles.sync");
                } else if (coreGroups.indexOf(groupToReturn.code) !== -1) {
                    groupToReturn.description = this.$t("admin.usersAndRoles.groupCoreDescription");
                } else if (groupToReturn.type === "TD") {
                    groupToReturn.description = this.$t("admin.usersAndRoles.groupTypeTD");
                } else {
                    groupToReturn.description = "";
                }
                return groupToReturn;
            });
            return dataToReturn;
        },
        editRole(inEditRow) {
            this.inEditRow = inEditRow;
            this.activateModalRole = true;
        },
        toRolesUsers() {
            this.$router.push("/admin");
        },
        createRole() {
            this.activateModalRole = true;
            this.inEditRow = null;
            this.$store.commit("main/setInterfaceDirty", true);
        },
        addUser(inEditRow) {
            this.inEditRow = inEditRow;
            this.manualAddModal = true;
        },
        addPermission(inEditRow) {
            this.inEditRow = inEditRow;
            this.addpermissionModal = true;
        },
        addUserClosed(event) {
            this.userModal = false;
            if (event) {
                this.inEditRow.users = this.userList.filter(user => event.indexOf(user.email) !== -1);
            }
        },
        dialogClosed(e) {
            if (e === "ROLE") {
                this.activateModalRole = false;
                this.inEditRow = null;
            } else {
                this.showEditUser = false;
            }
        },
        actionsDlg($event) {
            if ($event.detailed === "action_save") {
                this.saved = true;
            }
            this.inEditRow = null;
            this.addpermissionModal = false;
            this.userModal = false;
            this.editRoleModal = false;
            this.activateModalRole = false;
        },
        afterHide() {
            this.$emit("closed", this.saved);
        },
        clickSearch() {
            this.clicked = !this.clicked;
        },
        editUser(inEditRow) {
            if (!this.dashboard) {
                this.inEditRow = inEditRow;
                this.showEditUser = true;
            }
        },
        filterData() {
            this.filteredRoleItems = this.roleList.filter(role => role.name.toLowerCase().includes(this.filter.toLowerCase()));
            this.filteredUsersItems = this.userList.filter(user => (user.userList ? (user.firstName.toLowerCase().includes(this.filter.toLowerCase())) : null)
                                            || (user.lastName ? (user.lastName.toLowerCase().includes(this.filter.toLowerCase())) : null)
                                            || (user.email ? (user.email.toLowerCase().includes(this.filter.toLowerCase())) : null));
        },

        manageGroupsApplication() {
            if (this.manageGroupsType && this.getGroupsListApp && !this.getGroupsListApp.length) {
                this.actionGetGroupsApps();
            }
        }
    }
};
